import React from "react";
import { inject, observer } from "mobx-react";
import { IAppStore } from "../../../../stores/Interfaces";
import {
  EDIT_DECLARANT,
  PermissionType,
} from "../../../../constants/authorize";
import { Option } from "../../../common/forms/Interfaces";
import Select from "../../columns/select";
import { NO, YES, YES_KEY } from "../../../../constants/values";
import { CHANGE_TABLE_CELL_EVENT } from "../../../../constants/events";

interface Props {
  option: string | number;
  options: Option[];
  entityKey: string;
  entityId: unknown;
  store?: IAppStore;
  eventKey?: string;
  permissions?: PermissionType;
}

const Exposed: React.FC<Props> = ({
  option,
  entityKey,
  entityId,
  store,
  options,
  eventKey = CHANGE_TABLE_CELL_EVENT,
  permissions = EDIT_DECLARANT,
}) => {
  if (store?.userStore.authorizeByPermission(permissions)) {
    return (
      <Select
        string={option}
        entityKey={entityKey}
        entityId={entityId}
        options={options}
        eventKey={eventKey}
      />
    );
  }

  return <>{option === YES_KEY ? YES : NO}</>;
};

export default inject("store")(observer(Exposed));
